import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { MarketResearchPage } from "@/components/site/MarketResearchPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-analysis/market-research")({
  head: () => ({
    meta: [
      { title: "Market Research - Media Analysis | Perceptica" },
      { name: "description", content: "Perceptica's market research draws on full-spectrum media analysis to map demand, competitors and narratives across Southeast Europe. Brief our analysts." },
      { property: "og:title", content: "Market Research - Media Analysis | Perceptica" },
      { property: "og:description", content: "Perceptica's market research draws on full-spectrum media analysis to map demand, competitors and narratives across Southeast Europe. Brief our analysts." },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Market Research - Media Analysis | Perceptica" },
      { name: "twitter:description", content: "Perceptica's market research draws on full-spectrum media analysis to map demand, competitors and narratives across Southeast Europe. Brief our analysts." },
      { property: "og:url", content: "https://perceptica.com/media-analysis/market-research" },
      ...ogImageMeta("en", "/media-analysis/market-research"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-analysis/market-research", service: { name: "Market research", description: "Perceptica market research for Southeast Europe.", serviceType: "Market research" } }),
  }),
  component: MarketResearchPage,
});
